import { render, staticRenderFns } from "./EmployeesStatistics.vue?vue&type=template&id=74cb8b91&"
import script from "./EmployeesStatistics.vue?vue&type=script&lang=js&"
export * from "./EmployeesStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports